module.exports = __webpack_public_path__ + "static/subset-UniNeueLight-5320b5f028df6e8fdbb5eb8c29c99acf.woff";